import { render, staticRenderFns } from "./WaitingForm.vue?vue&type=template&id=acb90ed4"
import script from "./WaitingForm.vue?vue&type=script&lang=js"
export * from "./WaitingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports